import React from "react";
import { makeStyles, Typography, Paper } from "@material-ui/core";
import { NODE_PALETTE, NODE_COLORS } from "./nodeTypes";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
  root: {
    width: 200,
    borderRight: `1px solid ${theme.palette.divider}`,
    background: theme.palette.background.paper,
    overflowY: "auto",
    flexShrink: 0
  },
  title: {
    padding: theme.spacing(1.5, 1.5, 0.5),
    fontWeight: 600,
    fontSize: 12,
    textTransform: "uppercase",
    color: theme.palette.text.secondary
  },
  hint: {
    padding: theme.spacing(0, 1.5, 1),
    fontSize: 11,
    color: theme.palette.text.secondary
  },
  item: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    margin: theme.spacing(0.5, 1),
    padding: theme.spacing(1),
    cursor: "grab",
    border: `1px solid ${theme.palette.divider}`,
    "&:active": { cursor: "grabbing" }
  },
  swatch: {
    width: 12,
    height: 12,
    borderRadius: 3,
    flexShrink: 0
  }
}));

const FlowNodePalette = () => {
  const classes = useStyles();

  const onDragStart = (event, nodeType) => {
    event.dataTransfer.setData("application/reactflow", nodeType);
    event.dataTransfer.effectAllowed = "move";
  };

  return (
    <div className={classes.root}>
      <Typography className={classes.title}>
        {i18n.t("chatFlows.editor.palette")}
      </Typography>
      <Typography className={classes.hint}>
        {i18n.t("chatFlows.editor.paletteHint")}
      </Typography>
      {NODE_PALETTE.map(item => (
        <Paper
          key={item.type}
          className={classes.item}
          elevation={0}
          draggable
          onDragStart={e => onDragStart(e, item.type)}
        >
          <span
            className={classes.swatch}
            style={{ background: NODE_COLORS[item.type] }}
          />
          <div>
            <Typography variant="body2">
              {i18n.t(`chatFlows.nodes.${item.type}`)}
            </Typography>
          </div>
        </Paper>
      ))}
    </div>
  );
};

export default FlowNodePalette;
